import React, { useContext, useEffect, useState } from "react";
import {
    Table,
    Form,
    Button,
    FloatingLabel,
    Modal,
    Tab,
    Tabs,
} from "react-bootstrap";

import Utils from "../../../../../Utils";
import ContextComponent from "../../../../../AppContext";

import DeleteIcon from "../../../../../../assets/img/Delete.png"
import UpArrowIcon from "../../../../../../assets/img/up-arrow.png"
import DownArrowIcon from "../../../../../../assets/img/down-arrow.png"

const EditQuestionPage = ({ props }) => {

    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);

    let editableQuestion = props?.editableQuestion || {};

    let [questionId, setQuestionId] = useState(editableQuestion?.id || "");
    let [question, setQuestion] = useState(editableQuestion?.question || "");
    let [description, setDescription] = useState(editableQuestion?.description || "");
    let [help, setHelp] = useState(editableQuestion?.help || "");
    let QUESTIONTYPE = Utils.QUESTION_TYPE || {};
    let [questionType, setQuestionType] = useState(editableQuestion?.questionType || QUESTIONTYPE[3].value);
    let [subSection, setSubSection] = useState(editableQuestion?.subsection || "");
    const [dependentQue, setDependentQue] = useState(editableQuestion?.dependent || false);
    const [dependentQuestionId, setDependentQuestionId] = useState(editableQuestion?.dependentQuestionId || "-1");
    const [questionsList, setQuestionsList] = useState({});

    const convertImageUrlToAbsolutePath = (imgPath) => {
        let absImagPath = Utils.getImagePath(imgPath)
        // console.log("absImagPath:::", absImagPath);
        return absImagPath;
    }

    let [image, setImage] = useState(editableQuestion?.image ? convertImageUrlToAbsolutePath(editableQuestion.image) : "");

    let [answerOptions, setAnswerOptions] = useState([]);
    useEffect(() => {
        const sortedAnswerOptions = editableQuestion?.answerOptions || [];
        sortedAnswerOptions.sort((a, b) => a.answerOrder - b.answerOrder);
        setAnswerOptions(sortedAnswerOptions);
    }, []);

    const hideModal = (e) => {
        props.setEditModalCanOpen(false);
    };

    const questionHandler = (e) => {
        setQuestion(e.currentTarget.value);
    };

    const descriptionHandler = (e) => {
        setDescription(e.currentTarget.value);
    };

    const helpHandler = (e) => {
        setHelp(e.currentTarget.value);
    };

    const questionTypeHandler = (e) => {
        setQuestionType(e.currentTarget.value);
    };

    const subSectionHandler = (e) => {
        setSubSection(e.currentTarget.value);
    };

    const dependentQuestionHandler = (e) => {
        setDependentQue(e.currentTarget.checked);
    }

    const dependentQuestionIdHandler = (e) => {
        setDependentQuestionId(e.currentTarget.value);
    }

    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetImage = e.currentTarget.attributes["imgname"].value;
        // let targetIndex = parseInt(
        //     e.currentTarget.attributes["imgindex"].value,
        //     10,
        // );
        document
            .querySelector(".indi-add-img-wrapper-" + targetImage)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetImage,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgPreviewEle.src = dataUri;
            // let imgObj = {};
            // imgObj[targetImage] = dataUri;
            // let updatedSiteInfo = { ...siteInfo, ...imgObj };
            // setSiteInfo(updatedSiteInfo);
            // imgPreviewEle.src = dataUri;
            setImage(dataUri);
        });
    };

    const handleKeyValueInputChange = (index, field, value) => {
        const newData = [...answerOptions];
        newData[index][field] = value;
        setAnswerOptions(newData);
    };

    const addRow = () => {
        const newRow = {
            answer: '',
            answervalue: '',
            weightage: '',
            answerHint: '',
            correct: false,
            answerColor: '#232762',
            textColor: '#ffffff',
            // answerOrder: answerOptions.length + 1,
        };

        // Add extra fields if it's a CHECKBOX_GROUP or dependentQue
        if (questionType === "CHECKBOX_GROUP") {
            newRow.groupName = '';
        }
        if (dependentQue) {
            newRow.answerRule = '';
        }

        setAnswerOptions([...answerOptions, newRow]);
    };

    const removeRow = (index) => {
        const newData = [...answerOptions];
        newData.splice(index, 1);
        setAnswerOptions(newData);
        // Update color and colorText fields of rows below the deleted row
        for (let i = index; i < newData.length; i++) {
            const answerColorInputId = `answerColor_${i}`;
            const textColorInputId = `textColor_${i}`;
            const prevAnswerColorInputId = `answerColor_${i + 1}`;
            const prevTextColorInputId = `textColor_${i + 1}`;

            const answerColorInput = document.getElementById(answerColorInputId);
            const textColorInput = document.getElementById(textColorInputId);
            const prevAnswerColorInput = document.getElementById(prevAnswerColorInputId);
            const prevTextColorInput = document.getElementById(prevTextColorInputId);

            if (answerColorInput && prevAnswerColorInput) {
                answerColorInput.value = prevAnswerColorInput.value;
            }
            if (textColorInput && prevTextColorInput) {
                textColorInput.value = prevTextColorInput.value;
            }
        }
    };

    const moveRow = (direction, index) => {
        // debugger;
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        if (newIndex >= 0 && newIndex < answerOptions.length) {
            const updatedKeyValues = [...answerOptions];
            const temp = updatedKeyValues[index];
            updatedKeyValues[index] = updatedKeyValues[newIndex];
            updatedKeyValues[newIndex] = temp;
            setAnswerOptions(updatedKeyValues);
            // Update UI for moved rows
            updateUIForMovedRows(index, newIndex);
        }

    }

    const updateUIForMovedRows = (index, newIndex) => {
        // Update color input fields
        const indexColorInput = document.getElementById(`answerColor_${index}`);
        const newIndexColorInput = document.getElementById(`answerColor_${newIndex}`);

        // Swap input values for moved rows
        if (indexColorInput && newIndexColorInput) {
            const tempValue = indexColorInput.value;
            indexColorInput.value = newIndexColorInput.value;
            newIndexColorInput.value = tempValue;

            // Trigger the change event manually
            indexColorInput.dispatchEvent(new Event('change'));
            newIndexColorInput.dispatchEvent(new Event('change'));
        }

        // Update color text fields
        const indexColorTextField = document.getElementById(`textColor_${index}`);
        const newIndexColorTextField = document.getElementById(`textColor_${newIndex}`);

        // Swap text field values for moved rows
        if (indexColorTextField && newIndexColorTextField) {
            const tempTextValue = indexColorTextField.value;
            indexColorTextField.value = newIndexColorTextField.value;
            newIndexColorTextField.value = tempTextValue;
        }
    }


    const textColorHandler = (index, field, e) => {
        let val = e.currentTarget.value;
        handleKeyValueInputChange(index, field, val);
        let colorInputId = `textColor_${index}`; // Construct the ID based on the index
        let logoEle1 = document.getElementById(colorInputId);
        logoEle1.value = val;
    };

    const textInputColorHandler = (index, field, e) => {
        let val = e.currentTarget.value;
        handleKeyValueInputChange(index, field, val);
        let textInputId = `textColor_text_${index}`;
        let logoEle = document.getElementById(textInputId);
        logoEle.value = val;
    };

    const answerColorHandler = (index, field, e) => {
        let val = e.currentTarget.value;
        handleKeyValueInputChange(index, field, val);
        let colorInputId = `answerColor_${index}`; // Construct the ID based on the index
        let logoEle1 = document.getElementById(colorInputId);
        logoEle1.value = val;
    };

    const answerInputColorHandler = (index, field, e) => {
        let val = e.currentTarget.value;
        handleKeyValueInputChange(index, field, val);
        let textInputId = `answerColor_text_${index}`;
        let logoEle = document.getElementById(textInputId);
        logoEle.value = val;
    };

    // Function to add order to answer options
    const addOrderToAnswerOptions = (questionInfo) => {
        let answerOptions = questionInfo.answerOptions;
        for (let i = 0; i < answerOptions.length; i++) {
            answerOptions[i].answerOrder = i + 1; // Adding order starting from 1
        }
        questionInfo.answerOptions = answerOptions;
    }

    const convertAbsolutePathToRelativePath = (imgPath) => {
        // Check if it contains the domain
        let domain = Utils.getDomainName();
        if (imgPath.includes(domain)) {
            // Replace the domain with an empty string
            return imgPath.replace(domain, '');
        }

        return imgPath;
    }

    // Normalizes answerOptions before submit
    const normalizeAnswerOptions = (answerOptions) => {
        return answerOptions.map((opt) => {
            let parsedRule;

            if (opt.answerRule) {
                try {
                    parsedRule = JSON.parse(opt.answerRule);
                } catch {
                    parsedRule = undefined; // validation should prevent this
                }
            }

            return {
                ...opt,
                // ensure answerRule is either parsed object or undefined
                ...(parsedRule ? { answerRule: parsedRule } : {}),
            };
        });
    };

    const _updateQuestion = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Updating Question",
        });

        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Question updated successfully!",
                type: "success",
            });

            props.loadFreshQuestions();
        };

        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Question update failed",
                type: "danger",
            });
            console.log(err);
        };

        let questionInfo = {
            question,
            description,
            help,
            image: convertAbsolutePathToRelativePath(image),
            questionType,
            subsection: subSection,
            answerOptions: normalizeAnswerOptions(answerOptions),
        };
        // add only if values are present
        if (dependentQue) {
            questionInfo.dependent = dependentQue;
        }
        if (dependentQuestionId && dependentQuestionId !== "-1") {
            questionInfo.dependentQuestionId = dependentQuestionId;
        }

        addOrderToAnswerOptions(questionInfo);

        try {
            // debugger;
            // console.log(formData);
            Utils.updateQuestion(questionId, questionInfo).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    }

    const validateData = () => {
        // 1. Dependent check
        if (dependentQue && (!dependentQuestionId || dependentQuestionId === "-1")) {
            setAlert({
                show: true,
                message: "Dependent question is required.",
                type: "danger",
            });
            return false;
        }

        // 2. Validate Answer Rule JSON (if present)
        for (let i = 0; i < answerOptions.length; i++) {
            const opt = answerOptions[i];
            if (opt?.answerRule) {
                let parsed;

                try {
                    // handle both string + already-parsed object
                    parsed =
                        typeof opt.answerRule === "string"
                            ? JSON.parse(opt.answerRule)
                            : opt.answerRule;
                } catch {
                    setAlert({
                        show: true,
                        message: `Invalid Answer Rule JSON at row ${i + 1
                            }. Must follow { "options": [ { "option": "A", "value": 1 } ] } format.`,
                        type: "danger",
                    });
                    return false;
                }

                // must be an object with "options" array
                if (
                    typeof parsed !== "object" ||
                    parsed === null ||
                    !Array.isArray(parsed.options)
                ) {
                    setAlert({
                        show: true,
                        message: `Invalid Answer Rule JSON at row ${i + 1
                            }. Missing "options" array.`,
                        type: "danger",
                    });
                    return false;
                }

                // options array must not be empty
                if (parsed.options.length === 0) {
                    setAlert({
                        show: true,
                        message: `Answer Rule JSON at row ${i + 1
                            } must have at least one option.`,
                        type: "danger",
                    });
                    return false;
                }

                // every item inside options must be { option: string, value: any }
                const valid = parsed.options.every(
                    (item) =>
                        item &&
                        typeof item === "object" &&
                        "option" in item &&
                        "value" in item
                );

                if (!valid) {
                    setAlert({
                        show: true,
                        message: `Invalid Answer Rule JSON at row ${i + 1
                            }. Each option must have "option" and "value".`,
                        type: "danger",
                    });
                    return false;
                }
            }
        }

        // 3. validate the isCorrect option
        const isQuiz = props?.isQuiz;
        const correctAnswers = answerOptions.filter(opt => opt.correct);
        if (isQuiz && correctAnswers.length === 0) {
            setAlert({
                show: true,
                message: "At least one answer option must be marked as correct.",
                type: "danger",
            });
            return false;
        }
        if (isQuiz && correctAnswers.length > 1) {
            setAlert({
                show: true,
                message: "Multiple correct answers are not allowed for quiz questions.",
                type: "warning",
            });
            return false;
        }

        return true;
    };

    const updateQuestion = (e) => {
        if (validateData()) {
            _updateQuestion();
        }
    }

    useEffect(() => { }, [props.editModalCanOpen]);

    const handleClose = (e) => {
        props.setEditModalCanOpen(false);
    };

    // this useEffect is to listen for dependent questions
    useEffect(() => {
        if (dependentQue && Object.keys(questionsList).length === 0) {
            setLoadingState({
                applyMask: true,
                text: "Loading",
            });
            // we need to make an API call only if we did not fetched the data.
            // and then set the data
            const success = (res) => {
                setLoadingState({
                    applyMask: false
                });
                // Inject "Select" as the first entry
                const updatedList = {
                    "-1": "Select",
                    ...res?.data
                };

                setQuestionsList(updatedList);
            }
            const failure = (err) => {
                setLoadingState({
                    applyMask: false
                });
                if (err?.redirect) {
                    setCanRedirectToLogin(true);
                }
                setAlert({
                    show: true,
                    message: err?.data?.message
                        ? err.data.message
                        : "Loading failed",
                    type: "danger",
                });
                console.log(err);
            };
            Utils.getAllQuestionsForSite(props?.siteid).then(success, failure);
        }

    }, [dependentQue]);

    return (
        <>
            <Modal centered show={props.editModalCanOpen} className="indi-full-modal" onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Question</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="indi-add-form-wrapper">
                        <Tabs
                            defaultActiveKey="general"
                            id="add-question-general-tab"
                            className="mb-3"
                        >
                            <Tab eventKey="general" title={<span className="tab-title">General</span>} className="indi-form-item-general-tab">
                                <div className="d-flex flex-column">
                                    <div className="indi-add-form-item d-flex flex-column">
                                        <div className="indi-add-form-item-input row">
                                            <FloatingLabel label="Question">
                                                <Form.Control
                                                    type="text"
                                                    className="indi-input-field"
                                                    id="question"
                                                    placeholder="Enter Question"
                                                    autoComplete="off"
                                                    defaultValue={question}
                                                    onChange={questionHandler}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                    <div className="indi-add-form-item d-flex flex-column">
                                        <div className="indi-add-form-item-input row">
                                            <FloatingLabel label="Best Practice">
                                                <Form.Control
                                                    as="textarea"
                                                    className="indi-input-field"
                                                    id="description"
                                                    placeholder="Enter Question Description"
                                                    autoComplete="off"
                                                    defaultValue={description}
                                                    onChange={descriptionHandler}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                    <div className="indi-add-form-item d-flex flex-column">
                                        <div className="indi-add-form-item-input row">
                                            <FloatingLabel label="International SOS Solution">
                                                <Form.Control
                                                    as="textarea"
                                                    className="indi-input-field"
                                                    id="help"
                                                    placeholder="Enter Question Help"
                                                    autoComplete="off"
                                                    defaultValue={help}
                                                    onChange={helpHandler}
                                                />
                                            </FloatingLabel>
                                        </div>
                                    </div>
                                    <div className="indi-add-form-item d-flex row">
                                        <div className="indi-add-form-item-input col">
                                            <FloatingLabel label="Question Type">
                                                <Form.Select
                                                    defaultValue={questionType}
                                                    id="questionType"
                                                    onChange={questionTypeHandler}
                                                    size="sm"
                                                    className="indi-input-field indi-input-select-field"
                                                >
                                                    {QUESTIONTYPE.map((qType, index) => (
                                                        <option value={qType.value} key={index}>
                                                            {qType.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </FloatingLabel>
                                        </div>
                                        <div className="indi-add-form-item-input col">
                                            <FloatingLabel label="Sub  Section">
                                                <Form.Control
                                                    type="text"
                                                    className="indi-input-field"
                                                    id="subsection"
                                                    placeholder="Enter Sub Section Name"
                                                    autoComplete="off"
                                                    defaultValue={subSection}
                                                    onChange={subSectionHandler}
                                                />
                                            </FloatingLabel>
                                        </div>
                                        <div className="indi-add-form-item-input col">
                                            <Form.Check
                                                type="switch"
                                                className="indi-input-switch-field"
                                                id="dependent"
                                                checked={dependentQue}
                                                label="Dependent Question"
                                                onChange={dependentQuestionHandler}
                                            />
                                        </div>
                                    </div>
                                    <div className="indi-add-form-item d-flex row">
                                        <div className="indi-add-form-item-input col">
                                            <label htmlFor="iconImage" className="form-label">Upload Image:</label>
                                            <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                <input
                                                    type="file"
                                                    imgname="image"
                                                    id="image"
                                                    imgindex={0}
                                                    className="indi-upload-picture-file-input"
                                                    onChange={onChangeImage}
                                                />
                                                <div className="indi-add-img-wrapper"></div>
                                            </div>
                                            <small className="form-text text-muted">
                                                <span className="image-specifications-text-highlight">Required size: </span>
                                                <span style={{ color: '#ff0000' }}>505px x 512px</span>,
                                                <span className="image-specifications-text-highlight"> Format: </span>
                                                <span style={{ color: '#ff0000' }}>PNG or JPEG</span>
                                            </small>
                                        </div>
                                        <div className="indi-add-form-item-input col">
                                            {/* <label htmlFor="iconImage" className="form-label mb-2">Image Preview:</label> */}
                                            <div className="indi-add-img-wrapper-image d-none">no preview</div>
                                            <img
                                                src={image}
                                                alt="background"
                                                className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image"
                                            />
                                        </div>
                                    </div>
                                    {dependentQue && Object.keys(questionsList).length > 0 && (
                                        <div className="indi-add-form-item d-flex row">
                                            <div className="indi-add-form-item-input col">
                                                <FloatingLabel label="Select Dependent Question">
                                                    <Form.Select
                                                        defaultValue={dependentQuestionId}
                                                        id="dependentQuestionId"
                                                        onChange={dependentQuestionIdHandler}
                                                        size="sm"
                                                        className="indi-input-field indi-input-select-field"
                                                    >
                                                        {Object.entries(questionsList).map(([id, question]) => (
                                                            <option value={id} key={id} title={question}>
                                                                {question?.length > 150 ? question.slice(0, 150) + '...' : question}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </FloatingLabel>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="answerOptions" title={<span className="tab-title">Answer Options</span>}>
                                <div className="indi-add-key-value-item d-flex flex-column">
                                    <Table responsive="sm">
                                        <thead className="indi-data-table-header">
                                            <tr>
                                                <th>Answer</th>
                                                <th>Answer value</th>
                                                <th>Weightage</th>
                                                <th>Answer hint</th>
                                                <th>Is Correct</th>
                                                {questionType === "CHECKBOX_GROUP" && <th>Group Name</th>}
                                                {dependentQue && <th>Answer Rule</th>}
                                                <th>Answer color</th>
                                                <th>Text color</th>
                                                <th>Delete</th>
                                                <th>Order</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {answerOptions.map((row, index) => (

                                                <tr key={index} className="indi-data-table1-tr">
                                                    <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                as="textarea"
                                                                className="indi-input-field"
                                                                placeholder={"Enter Answer"}
                                                                autoComplete="off"
                                                                value={row.answer}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'answer', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                as="textarea"
                                                                className="indi-input-field"
                                                                placeholder={"Enter Answer Value"}
                                                                autoComplete="off"
                                                                value={row.answervalue}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'answervalue', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                placeholder={"Enter weightage"}
                                                                autoComplete="off"
                                                                value={row.weightage}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'weightage', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                as="textarea"
                                                                className="indi-input-field"
                                                                placeholder={"Enter Answer Hint"}
                                                                autoComplete="off"
                                                                value={row.answerHint}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'answerHint', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Check
                                                                type="switch"
                                                                className="indi-input-switch-field"
                                                                checked={row.correct || false}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'correct', !row.correct)}
                                                            />
                                                        </div>
                                                    </td>
                                                    {questionType === "CHECKBOX_GROUP" && <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                placeholder={"Enter Group Name"}
                                                                autoComplete="off"
                                                                value={row?.groupName || ""}
                                                                onChange={(e) => handleKeyValueInputChange(index, 'groupName', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>
                                                    }
                                                    {dependentQue && <td>
                                                        <div className="indi-data-table1-wrapper d-flex indi-text-area-row">
                                                            <Form.Control
                                                                as="textarea"
                                                                className="indi-input-field"
                                                                placeholder={"Enter Answer Rule(JSON)"}
                                                                autoComplete="off"
                                                                value={
                                                                    typeof row?.answerRule === "object" && row?.answerRule !== null
                                                                        ? JSON.stringify(row.answerRule, null, 2) // pretty print
                                                                        : row?.answerRule || ""
                                                                }
                                                                onChange={(e) => handleKeyValueInputChange(index, 'answerRule', e.target.value)}
                                                            />
                                                        </div>
                                                    </td>}
                                                    <td>
                                                        <div className="indi-add-form-item d-flex">
                                                            <div className="indi-visibility-hidden">
                                                                <Form.Control
                                                                    type="text"
                                                                    className="indi-input-field"
                                                                    // id="answerColor"
                                                                    id={`answerColor_text_${index}`}
                                                                    placeholder={"Enter Answer Color"}
                                                                    autoComplete="off"
                                                                    // onChange={textColorHandler}
                                                                    onChange={(e) => answerColorHandler(index, 'answerColor', e)}
                                                                    defaultValue={row.answerColor}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <Form.Control
                                                                    type="color"
                                                                    className="indi-input-field indi-color-input-field"
                                                                    // id="answerColor1"
                                                                    id={`answerColor_${index}`}
                                                                    placeholder=""
                                                                    autoComplete="off"
                                                                    onChange={(e) => answerInputColorHandler(index, 'answerColor', e)}
                                                                    defaultValue={row.answerColor}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="indi-add-form-item d-flex">
                                                            <div className="indi-visibility-hidden">
                                                                <Form.Control
                                                                    type="text"
                                                                    className="indi-input-field"
                                                                    // id="textColor"
                                                                    id={`textColor_text_${index}`}
                                                                    placeholder={"Enter Text Color"}
                                                                    autoComplete="off"
                                                                    // onChange={textColorHandler}
                                                                    onChange={(e) => textColorHandler(index, 'textColor', e)}
                                                                    defaultValue={row.textColor}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <Form.Control
                                                                    type="color"
                                                                    className="indi-input-field indi-color-input-field"
                                                                    // id="textColor1"
                                                                    id={`textColor_${index}`}
                                                                    placeholder=""
                                                                    autoComplete="off"
                                                                    onChange={(e) => textInputColorHandler(index, 'textColor', e)}
                                                                    defaultValue={row.textColor}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <img
                                                                className="indi-add-question-delete-icon-img"
                                                                src={DeleteIcon}
                                                                alt="delete"
                                                                onClick={() => removeRow(index)}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <img
                                                                src={UpArrowIcon}
                                                                alt="up"
                                                                onClick={index > 0 ? () => moveRow('up', index) : null} // Conditionally set onClick
                                                                style={{ cursor: index > 0 ? 'pointer' : 'not-allowed', width: '15px', margin: '0 5px', opacity: index > 0 ? '1' : '0' }} // Apply different styles based on condition
                                                            />
                                                            <img
                                                                src={DownArrowIcon}
                                                                alt="down"
                                                                onClick={index < answerOptions.length - 1 ? () => moveRow('down', index) : null} // Conditionally set onClick
                                                                style={{ cursor: index < answerOptions.length - 1 ? 'pointer' : 'not-allowed', width: '15px', margin: '0 5px', opacity: index < answerOptions.length - 1 ? '1' : '0' }} // Apply different styles based on condition
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                    <div className="w-100">
                                        <Button
                                            onClick={addRow}
                                            className="float-end"
                                            // size="sm"
                                            style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}
                                        >
                                            Add Row
                                        </Button>
                                    </div>

                                </div>
                            </Tab>
                        </Tabs>
                    </form>
                    <div className="indi-add-footer">
                        <div className="indi-add-page-footer-btn-wrapper float-right">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={hideModal}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={updateQuestion}
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default EditQuestionPage;